import { Routes, Route } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ProtectedRoute, AdminRoute, PublicOnlyRoute } from "@/components/layout/ProtectedRoute";

import { Welcome } from "@/pages/Welcome";
import { AuthCallback } from "@/pages/auth/AuthCallback";
import { OnboardingProfile } from "@/pages/auth/OnboardingProfile";
import { ForgotPassword } from "@/pages/auth/ForgotPassword";
import { ResetPassword } from "@/pages/auth/ResetPassword";

import { Home } from "@/pages/Home";
import { Matches } from "@/pages/Matches";
import { MatchDetail } from "@/pages/MatchDetail";
import { CouponDetail } from "@/pages/CouponDetail";
import { Gift } from "@/pages/Gift";
import { Notifications } from "@/pages/Notifications";
import { Profile } from "@/pages/Profile";
import { ProfileEdit } from "@/pages/ProfileEdit";
import { Plans } from "@/pages/Plans";
import { Wallet } from "@/pages/Wallet";
import { Deposit } from "@/pages/Deposit";
import { Withdraw } from "@/pages/Withdraw";
import { PaymentReturn } from "@/pages/PaymentReturn";
import { Referral } from "@/pages/Referral";
import { History } from "@/pages/History";
import { NotFound } from "@/pages/NotFound";

import { Terms } from "@/pages/legal/Terms";
import { Privacy } from "@/pages/legal/Privacy";
import { LegalNotice } from "@/pages/legal/LegalNotice";

import { AdminLayout } from "@/pages/admin/AdminLayout";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminWithdrawals } from "@/pages/admin/AdminWithdrawals";
import { AdminDeposits } from "@/pages/admin/AdminDeposits";
import { AdminGiftPool } from "@/pages/admin/AdminGiftPool";
import { AdminMembers } from "@/pages/admin/AdminMembers";
import { AdminBroadcast } from "@/pages/admin/AdminBroadcast";
import { AdminFeaturedMatches } from "@/pages/admin/AdminFeaturedMatches";

export default function App() {
  return (
    <Routes>
      {/* Pages publiques (légales accessibles partout) */}
      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/privacy" element={<Privacy />} />
      <Route path="/legal/notice" element={<LegalNotice />} />

      {/* Auth flow */}
      <Route element={<PublicOnlyRoute />}>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/auth/forgot-password" element={<ForgotPassword />} />
      </Route>
      <Route path="/auth/callback" element={<AuthCallback />} />
      {/* Reset password : accessible avec ou sans session active —
          Supabase établit une session "recovery" automatiquement quand
          on arrive avec le hash du lien email. */}
      <Route path="/auth/reset-password" element={<ResetPassword />} />

      {/* Onboarding (auth requis mais profil incomplet OK) */}
      <Route element={<ProtectedRoute requireOnboarded={false} />}>
        <Route path="/auth/onboarding" element={<OnboardingProfile />} />
      </Route>

      {/* App connectée */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Home />} />
          <Route path="/matches" element={<Matches />} />
          <Route path="/match/:id" element={<MatchDetail />} />
          <Route path="/coupon/:id" element={<CouponDetail />} />
          <Route path="/gift" element={<Gift />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/edit" element={<ProfileEdit />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/wallet/deposit" element={<Deposit />} />
          <Route path="/wallet/withdraw" element={<Withdraw />} />
          <Route path="/referral" element={<Referral />} />
          <Route path="/history" element={<History />} />
        </Route>
        {/* Page sans bottom nav. Le format /:txId est le nouveau (PayDunya
            rajoute ?token=... à la fin de l'URL de retour) ; l'ancien
            format ?tx=... reste supporté pour les transactions déjà en
            cours au moment du déploiement. */}
        <Route path="/payment/return/:txId" element={<PaymentReturn />} />
        <Route path="/payment/return" element={<PaymentReturn />} />
      </Route>

      {/* Admin */}
      <Route element={<AdminRoute />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="deposits" element={<AdminDeposits />} />
          <Route path="withdrawals" element={<AdminWithdrawals />} />
          <Route path="gift-pool" element={<AdminGiftPool />} />
          <Route path="members" element={<AdminMembers />} />
          <Route path="broadcast" element={<AdminBroadcast />} />
          <Route path="featured" element={<AdminFeaturedMatches />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
